import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { TonConnectUIProvider } from '@tonconnect/ui-react'
import React, { FC } from 'react'
import ReactDOM from 'react-dom/client'
import { IntlProvider } from 'react-intl'
import { App } from './App'
import { loadLocaleData } from './Index.functions'
import { AppContextProvider } from './contexts/App.context'
import { OnboardingProvider } from './contexts/OnboardingContext'
import { ThemeProvider } from './hooks/useTheme'
import { detectBrowserLanguage } from './functions/detectBrowserLanguage'
import { initSentry } from './utils/sentry'
import './styles/reset.css'
import './styles/themes.css'
import './styles/bottomsheet.css'

// Initialize Sentry as early as possible
initSentry()

const rootElement = document.getElementById('root')

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement)

  const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
  })

  const bootstrapApplication = async (Component: FC) => {
    const language = detectBrowserLanguage()
    const messages = await loadLocaleData(language)

    root.render(
      <TonConnectUIProvider
        manifestUrl="https://tma.testnet.votebox.io/tonconnect-manifest.json"
        widgetRootId="tc-widget-root"
      >
        <QueryClientProvider client={queryClient}>
          <AppContextProvider language={language}>
            <ThemeProvider defaultTheme="light">
              <OnboardingProvider>
                <IntlProvider
                  messages={messages}
                  locale={language}
                  defaultLocale="ru"
                >
                  <Component />
                </IntlProvider>
              </OnboardingProvider>
            </ThemeProvider>
          </AppContextProvider>
        </QueryClientProvider>
      </TonConnectUIProvider>,
    )
  }

  bootstrapApplication(App)

  // Включаем HMR
  if (module.hot) {
    module.hot.accept('./App', async () => {
      const { App: NextApp } = await import('./App')
      bootstrapApplication(NextApp)
    })
  }
}
